window.addEventListener('scroll', (e) => {
  if (window.pageYOffset > 50) {
    document.querySelector('.header').classList.add('header_fixed');
  }
  else {
    document.querySelector('.header').classList.remove('header_fixed');
  }
});

document.querySelectorAll('.smooth-link').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();

    document.querySelector(this.getAttribute('href')).scrollIntoView({
      behavior: 'smooth'
    });
  });
});

// select для карт
window.addEventListener('load', function () {
  const citySelect = document.querySelector('.map__select');
  if (citySelect) {
    customSelect(citySelect);
  }
});

// карта
const createMark = (mark) => {
  return new ymaps.Placemark(mark[0], {
    hintContent: mark[1],
    balloonContent: `
<div style="max-width: 245px; line-height: 1.4; font-size: 12px; font-weight: 300; margin-right: -20px;">
<div style="font-weight: 700; font-size: 14px; margin-bottom: 6px;">${mark[1]}</div>
<div style="font-weight: 500; color: #808080;">Адрес магазина:</div>
<div style="margin-bottom: 5px;">${mark[2]}</div>
<div style="font-weight: 500; color: #808080;">Время работы:</div>
<div style="margin-bottom: 5px;">${mark[3]}</div>
<span style="font-weight: 500; color: #808080;">Телефон:</span>
<a href="tel:${mark[4].replace(/[-+()\s]/g, '')}" style="margin-bottom: 5px; color: inherit; text-decoration:none;">${mark[4]}</a>
<img style="display:block; width: 100%; height: auto; margin-top: 8px;" src="img/content/${mark[5]}" alt="${mark[1]}">
</div>
    `,
  }, {
    iconLayout: 'default#image',
    iconImageHref: '/img/content/icon_map.png',
    iconImageSize: [34, 39],
    iconImageOffset: [-10, -39]
  })
};
let myMap;
const createMap = (center, marks) => {
  ymaps.ready(init);

  function init() {
    myMap = new ymaps.Map("map", {
      center: center,
      //controls: [],
      zoom: 10,
    });
    myMap.behaviors.disable('scrollZoom');
    marks.map((mark) => {
      myMap.geoObjects.add(createMark(mark));
    })
  }
};

const selectCity = async (city) => {
  let response = await fetch('./sampleData.json');
  let result = await response.json();
  return result[city];
};

const mapWrapper = document.getElementById('map');
if (mapWrapper) {
  selectCity('moscow').then(
    (({center, marks}) => createMap(center, marks))
  );

  const citySelect = document.querySelector('.map__select');


  citySelect.addEventListener('change', (e) => {
    myMap.destroy();
    selectCity(e.target.value).then(
      (({center, marks}) => createMap(center, marks))
    );
  })
}

(function ($) {
  $(function () {
    const cboxOptions = {
      width: '90%',
      height: '90%',
      maxWidth: '90%',
      maxHeight: '90%',
      rel: 'gal',
      opacity: '0.6',
      current: "Фото {current} из {total}"
    };
    $('.colorbox-inline').colorbox(cboxOptions);
    $(window).resize(function(){
      $.colorbox.resize({
        width: window.innerWidth > parseInt(cboxOptions.maxWidth) ? cboxOptions.maxWidth : cboxOptions.width,
        height: window.innerHeight > parseInt(cboxOptions.maxHeight) ? cboxOptions.maxHeight : cboxOptions.height
      });
    });
  });
})(jQuery);